import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Butt from '../c/Butt';
import { T } from '../traks';
import { A } from '../routes';
import { site_name, site_base } from '../Site';
import { faq_entries } from './FAQ';

const BigHeadlineBox = ({ txt }) => {
	return (
		<div className="d-flex justify-content-center pt-4 pt-md-5">
			<div className='d-flex justify-content-center align-items-center about_us_big_headline_box_geometry about_us_big_headline_box_color'>
				{txt}
			</div>
		</div>
	);
}

const FancyFAQEntry = ({ faq_entry }) => {
	const [ exp, setExp ] = useState(false);

	return (
		<div className='d-flex flex-column w-100 about_us_faq_box p-3'>
			<div className='d-flex w-100 justify-content-between align-items-center'>
				<div className='question'>{faq_entry.q}</div>
				{exp ?
					<div className='cursor-pointer pl-2' onClick={() => setExp(false)}><img alt='close question' src='/gfx/fancy-faq-minus-icon-0.svg'/></div>
				:
					<div className='cursor-pointer pl-2' onClick={() => setExp(true)}><img alt='open question' src='/gfx/fancy-faq-plus-icon-0.svg'/></div>
				}
			</div>
			<div>
				{exp && <div className='answer pt-2'>{faq_entry.a}</div>}
			</div>
		</div>
	);
}

const SelectedQsFromFAQ = () => {
	const ids2show = [1, 17, 18, 19, 20, 21, 22, 23, 24 ];

	return faq_entries.map( (faq_entry) => {
		if(ids2show.includes(faq_entry.id))
			return <Col xs={12} md={6} key={'faq' + faq_entry.id} className='pb-3'><FancyFAQEntry faq_entry={faq_entry} /></Col>;
		else
			return null;
		})
};

const AboutUs = () => {
	return (
	<Container fluid className='bg-white p-0'>
		<div className="ad_frontpage_top_blop">
                        <Container className="py-4">
                                <Row className='pb-md-5 pb-3'>
                                <Col xs="12" md="6" className="my-auto mx-auto pb-5">
					<div className="text-center about_us_h1 fw_600" ><T>Welcome to {site_name}!</T></div>
                                        <div className="about_us_header_text text-center pt-4 pb-md-5">
						<T>
						{site_name} is an investment game where participants can trade stocks with fictional
						money but at real, live-updated prices. - This allows everyone to try their hand
						at the stock market in a fun, secure, and realistic way through play.
						</T>
					</div>
                                </Col>
                                </Row>
                        </Container>
		</div>
		<div className='d-none d-md-flex justify-content-center' style={{marginTop: "-100px"}}>
			<img src='https://static.aktiedysten.dk/imgs/about-us-lady-0.webp'
				alt='lady'
				className='overflow-hidden pr-4'
				srcSet='https://static.aktiedysten.dk/imgs/about-us-lady-0@2.webp 2x'
				width='460' height='200'
				style={{borderRadius: "5px", width: "460px", height: "200px"}}
			/>
			<img src='https://static.aktiedysten.dk/imgs/about-us-hands-0.webp'
				alt='hands'
				className='overflow-hidden'
				srcSet='https://static.aktiedysten.dk/imgs/about-us-hands-0@2.webp 2x'
				width='598' height='290'
				style={{borderRadius: "5px", width: "598px", height: "290px"}}
			/>
		</div>
		<div className='d-flex d-md-none justify-content-between px-3' style={{marginTop: "-30px"}}>
			<img src='https://static.aktiedysten.dk/imgs/about-us-lady-0.webp'
				alt='lady'
				className='overflow-hidden'
				width='146' height='82'
				style={{borderRadius: "5px", width: "146px", height: "82px"}}
			/>
			<img src='https://static.aktiedysten.dk/imgs/about-us-hands-0.webp'
				alt='hands'
				className='overflow-hidden'
				width='190' height='118'
				style={{borderRadius: "5px", width: "190px", height: "118px"}}
			/>
		</div>
		<Container className="about_us_page">
			<Row className="px-md-5">
				<Col xs="12" className="pl-md-5 about_us_h2 fw_600">
					<div className='py-3'>
						<T>
						Play, Learning,<br />
						and Community
						</T>
					</div>
				</Col>
				<Col xs="12" md="6" className="pl-md-5">
					<p><T>
					The game appeals to anyone interested in stocks and investing, especially beginners
					who want to learn how to invest, as well as more experienced investors who want to
					practice and perhaps try out new strategies. {site_name} is used today in education at all
					levels, from elementary school to university. Finally, {site_name} is widely used by friends
					and colleagues as a fun game to challenge each other and find out who the best investor
					is - an entertaining way to cultivate and strengthen communities.
					</T></p>
				</Col>
				<Col xs="12" md="6" className="pr-md-5 pl-md-4 pt-md-4">
					<p><T>
					{site_name} is created with the ambition of providing users with insight and a
					responsible approach to investments. Therefore, we combine the game with learning and
					dissemination of investment knowledge through inspiring articles, podcasts, Q&amp;A formats,
					and educational materials. A range of experts share knowledge and perspectives, and users
					also have the opportunity to share experiences and insights with each other.
					</T></p>
				</Col>
				<Col xs="12" className="fw_600 text-center pt-md-5">
					<T>- An entertaining way to create, grow and strenghten communities.</T>
				</Col>
				<Col xs="12" className="fw_600 text-center pt-3 pb-5">
					<A href='/new_game'>
						<Butt className='ad_rbtn px-5 py-2'><T>Start game</T></Butt>
					</A>
				</Col>
			</Row>
		</Container>
		<Container fluid className="about_us_page px-0" style={{backgroundColor: "#F9F9FA"}}>
			<Container className="pb-5">
				<div className='about_us_h3 text-center py-3 py-md-5 fw_600'>
					<T>A Growing Community</T>
				</div>
				<div className='d-flex justify-content-center pb-md-3'>
					<div className='d-flex align-items-center'>
						<div>
							<svg viewBox="0 0 9 30" width="9" height="30">
								<rect width="9" height="30" rx="4.5" fill="#69D1BD" />
							</svg>
						</div>
						<div className='pl-2 pr-4 pr-md-5' style={{color: "rgba(49, 50, 67, 0.70)", fontSize: "14px", fontWeight: "500"}}>
							<T>Denmark</T>
						</div>
					</div>
					<div className='d-flex align-items-center'>
						<div>
							<svg viewBox="0 0 9 30" width="9" height="30">
								<rect width="9" height="30" rx="4.5" fill="#B330D4" />
							</svg>
						</div>
						<div className='pl-2 pr-4 pr-md-5' style={{color: "rgba(49, 50, 67, 0.70)", fontSize: "14px", fontWeight: "500"}}>
							<T>Sweden</T>
						</div>
					</div>
					<div className='d-flex align-items-center'>
						<div>
							<svg viewBox="0 0 9 30" width="9" height="30">
								<rect width="9" height="30" rx="4.5" fill="#6C60FF" />
							</svg>
						</div>
						<div className='pl-2' style={{color: "rgba(49, 50, 67, 0.70)", fontSize: "14px", fontWeight: "500"}}>
							<T>Germany</T>
						</div>
					</div>
				</div>
				<div className='d-flex justify-content-center mw-100'>
					<img className='mw-100' width="895" height="358" alt="Data graf" src="https://static.aktiedysten.dk/gfx/about-us-graph-0.svg" />
				</div>
			</Container>
		</Container>
		<Container className="about_us_page pb-4 pb-md-5">
			<div className='about_us_h3 text-center py-4 py-md-5 fw_600'>
				<T>Explore and Discover</T>
			</div>
			<Row>
				<Col xs="12" className="text-center pb-4">
					<div>
						<T>
						Here at {site_name}, we take the stock market seriously, but we also believe that
						learning can be fun and exciting. That's why we have created a universe where you
						can explore and learn about stocks risk-free through our gaming environment. Go on
						a journey in our world and experience how enjoyable and educational it can be to
						invest in stocks.
						</T>
					</div>
				</Col>
				<Col xs="12" md="6">
					<div className='d-flex'>
						<img className='about_us_pictograms' alt='play against friends' src='https://static.aktiedysten.dk/gfx/about-us-people-creditcard-0.svg' />
						<div className='d-flex flex-column pl-3'>
							<div className='about_us_h4 fw_600 pt-md-3'>
								<T>Start or Join Game</T>
							</div>
							<div>
								<T>
								Who is the best investor among your friends or colleagues?
								Create a <A className="ad_blue_link" href="/new_game">private duel</A>,
								invite your friends, and challenge each other. You can also
								participate in our ongoing <A href="/games">prize games</A> (reward games), where
								everyone can join for free.
								</T>
							</div>
						</div>

					</div>
				</Col>
				<Col xs="12" md="6">
					<div className='d-flex'>
						<img className='about_us_pictograms' alt='play against friends' src='https://static.aktiedysten.dk/gfx/about-us-girl-education-0.svg' />
						<div className='d-flex flex-column pl-3'>
							<div className='about_us_h4 fw_600 pt-md-3'>
								<T>Education with {site_name}</T>
							</div>
							<div>
								<T>
								{site_name} is currently used by a wide range of teachers as part
								of educational programs in various subjects and at different
								levels. From 7th grade to university level, the game is used for
								edutainment, motivation, and introduction to various subjects such
								as economics, mathematics, and social sciences.
								</T>
							</div>
						</div>

					</div>
				</Col>
				<Col xs="12" md="6">
					<div className='d-flex'>
						<img className='about_us_pictograms' alt='play against friends' src='https://static.aktiedysten.dk/gfx/about-us-guy-join-0.svg' />
						<div className='d-flex flex-column pl-3'>
							<div className='about_us_h4 fw_600 pt-md-3'>
								<T>Partnerships &amp; Branded Games</T>
							</div>
							<div>
								<T>
								In a partnership(cooperation) agreement with {site_name}, we offer
								branded games, branding on our materials, social media, and within
								our game, as well as a range of activations where you become the
								focal point.
								- Read more <a alt='partnership site' href='https://together.traderr.com/become-a-partner/'>here</a>.
								</T>
							</div>
						</div>

					</div>
				</Col>
				<Col xs="12" md="6">
					<div className='d-flex'>
						<img className='about_us_pictograms' alt='play against friends' src='https://static.aktiedysten.dk/gfx/about-us-guys-education-0.svg' />
						<div className='d-flex flex-column pl-3 pt-md-3'>
							<div className='about_us_h4 fw_600'>
								<T>Get Started and Tutorials</T>
							</div>
							<div>
								<T>
								We want to ensure that you have the best experience when using
								{site_name}, and that's why we have gathered everything you need to
								know to use the platform in our tutorials. Read more in our <A href='/faq'>FAQ</A>.
								</T>
							</div>
						</div>

					</div>
				</Col>
			</Row>
		</Container>
		<Container fluid className="about_us_page" style={{width: "95%", borderRadius: "30px", backgroundColor: "#F9F9FA"}}>
		<Container>
			<div className='about_us_h3 text-center pt-4 pt-md-5 fw_600'>
				<T>Getting Started</T>
			</div>
			<Row className='pb-4 pb-md-5'>
				<Col xs="12" md="4">
					<BigHeadlineBox txt={"1."} />
					<div className="text-center">
						<div className="about_us_h4 fw_600 pt-4">
							<T>Start a game</T>
						</div>
						<T>
						Click the <A href="/new_game">New Game</A> button on the game page (or one of the other buttons on the site that
						starts a game). This will start a new investment game with the markets, fees, timeframes,
						etc. that suit your preferences. You can visit our <A href="/equity-abc">Investment ABC</A> for guidance, terms, etc.
						</T>
					</div>
				</Col>
				<Col xs="12" md="4">
					<BigHeadlineBox txt={"2."} />
					<div className="text-center">
						<div className="about_us_h4 fw_600 pt-4">
							<T>Invite your friends</T>
						</div>
						<T>
						As soon as you click "Start Game" after creating it, you will have the opportunity to
						invite friends or colleagues. Playing together is much more fun!
						</T>
					</div>
				</Col>
				<Col xs="12" md="4">
					<BigHeadlineBox txt={"3."} />
					<div className="text-center">
						<div className="about_us_h4 fw_600 pt-4">
							<T>Set up your portfolio</T>
						</div>
						<T>
						Play and learn on the training ground. Here, you can take risks without any real
						consequences and see if you can earn the title of the best investor. Find your first stock
						in the search field and click on the trade button.
						</T>
					</div>
				</Col>
			</Row>
		</Container>
		</Container>
		<Container className="about_us_page">
			<div className="text-center py-5" style={{fontSize: "18px", lineHeight: "36px"}}>
				<div className="fw_600"><T>Need help?</T></div>
				<T>
				We are always ready to assist you in getting started. Don't hesitate to contact us at
				info@{site_base}. You can also check out our <A href="/faq">FAQ</A>, where your questions may
				already be answered.
				</T>
			</div>
			<div className='text-center pb-4 pb-md-5'>
				<A href='/new_game'>
					<Butt className='ad_rbtn px-5 py-2'><T>Start game</T></Butt>
				</A>
			</div>
		</Container>
		<Container>
			<div className='about_us_h3 text-center py-4 py-md-5 fw_600'>
				<T>Frequently Asked Questions</T>
			</div>
			<Row>
				<SelectedQsFromFAQ />
			</Row>
			<div className='pt-4 pb-5 py-md-5'>
				<A href='/faq'><div className='text-center ad_main_green'><b><T>See more questions and answers</T></b></div></A>
			</div>
		</Container>
		<Container>
			<Row className='pb-5'>
				<Col xs="12" md="3" className='d-flex align-items-center justify-content-center pb-4 pb-md-0'>
					<div>
						<img src="https://static.aktiedysten.dk/imgs/mira-round-182px-0.webp" alt="M. N. Rasmussen"
							srcSet="https://static.aktiedysten.dk/imgs/mira-round-365px-0.webp 2x" />
					</div>
				</Col>
				<Col xs="12" md="8" className='d-flex flex-column justify-content-center'>
					<p>
						<T>
						We are passionate about making {site_name} as user-friendly as possible, and an
						entertaining game for you and your friends.
						</T>
					</p>
					<p>
						<T>
						There's a lot on the drawing board, but we'd love to hear from you if you have a
						great idea. So please send feedback, praise, and good ideas to <b className='ad_main_green'>info@{site_base}</b>.
						</T>
					</p>
					<div className="pt-2">
						<strong>Michael Niels Rasmussen</strong><br />
						<T>E-mail</T>: mira@aktiedysten.dk<br />
						<T>Phone</T>: +4528770933<br />
					</div>
				</Col>
			</Row>
		</Container>
	</Container>
	);
}

export default AboutUs;



// WEBPACK FOOTER //
// ./src/p/AboutUs.js